import { resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_avatar, {
    color: "primary lighten-2",
    class: "text-white",
    size: "16",
    textContent: _toDisplayString(_ctx.message)
  }, null, 8, ["textContent"])), [
    [_directive_tooltip, _ctx.importFECTooltip, "top"]
  ])
}